// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__3RMcH","errorLogs":"styles_errorLogs__2gmah"};